
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("awHlv", function(module, exports) {
var $14957aea32c8ee8e$export$686dd843fdf311d4 = /*#__PURE__*/ function(SyncBlockError) {
    SyncBlockError["Errored"] = "errored";
    SyncBlockError["NotFound"] = "not_found";
    SyncBlockError["Forbidden"] = "forbidden";
    SyncBlockError["InvalidRequest"] = "invalid_request";
    SyncBlockError["RateLimited"] = "rate_limited";
    SyncBlockError["Conflict"] = "conflict";
    SyncBlockError["ServerError"] = "server_error";
    SyncBlockError["InvalidContent"] = "invalid_content";
    SyncBlockError["Offline"] = "offline";
    return SyncBlockError;
}({});
module.exports["SyncBlockError"] = $14957aea32c8ee8e$export$686dd843fdf311d4;

});

parcelRegister("cFpEg", function(module, exports) {

var $d925B = parcelRequire("d925B");

const $22be2fac1f3375a4$export$7fc2c997455452c8 = (error)=>{
    try {
        return JSON.stringify(error);
    } catch  {
        return undefined;
    }
};
const $22be2fac1f3375a4$export$999ed1af1b20ac2d = (actionSubjectId, error)=>({
        action: (0, $d925B.ACTION).ERROR,
        actionSubject: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
        actionSubjectId: actionSubjectId,
        eventType: (0, $d925B.EVENT_TYPE).OPERATIONAL,
        attributes: {
            error: error
        }
    });
const $22be2fac1f3375a4$export$94dcd08406353dba = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_FETCH, error);
const $22be2fac1f3375a4$export$c5131f589148b9d3 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_GET_SOURCE_INFO, error);
const $22be2fac1f3375a4$export$adc2363832f8735d = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE, error);
const $22be2fac1f3375a4$export$154595d209a77913 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).REFERENCE_SYNCED_BLOCK_UPDATE, error);
const $22be2fac1f3375a4$export$5d2f0c264cf49280 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_CREATE, error);
const $22be2fac1f3375a4$export$cd0aaab38ff32ec2 = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_DELETE, error);
const $22be2fac1f3375a4$export$e40ed1768baf5d1e = (error)=>$22be2fac1f3375a4$export$999ed1af1b20ac2d((0, $d925B.ACTION_SUBJECT_ID).SYNCED_BLOCK_UPDATE_CACHE, error);
module.exports["stringifyError"] = $22be2fac1f3375a4$export$7fc2c997455452c8;
module.exports["fetchErrorPayload"] = $22be2fac1f3375a4$export$94dcd08406353dba;
module.exports["getSourceInfoErrorPayload"] = $22be2fac1f3375a4$export$c5131f589148b9d3;
module.exports["updateErrorPayload"] = $22be2fac1f3375a4$export$adc2363832f8735d;
module.exports["updateReferenceErrorPayload"] = $22be2fac1f3375a4$export$154595d209a77913;
module.exports["createErrorPayload"] = $22be2fac1f3375a4$export$5d2f0c264cf49280;
module.exports["deleteErrorPayload"] = $22be2fac1f3375a4$export$cd0aaab38ff32ec2;
module.exports["updateCacheErrorPayload"] = $22be2fac1f3375a4$export$e40ed1768baf5d1e;

});

parcelRegister("eB0XO", function(module, exports) {

var $6RJVA = parcelRequire("6RJVA");

const $131664fc3d6b407d$var$isSyncBlockProduct = (product)=>{
    return (0, $6RJVA.SYNC_BLOCK_PRODUCTS).includes(product);
};
const $131664fc3d6b407d$export$8aafdd7901afa57f = (resourceId)=>{
    if (!resourceId) return undefined;
    const [product, contentId, uuid, ...rest] = resourceId.split('/');
    // invalid if any part is missing or there are extra parts
    if (!product || !contentId || !uuid || rest.length > 0) return undefined;
    // invalid if product is not recognized
    if (!$131664fc3d6b407d$var$isSyncBlockProduct(product)) return undefined;
    return {
        product: product,
        contentId: contentId,
        uuid: uuid
    };
};
module.exports["parseResourceId"] = $131664fc3d6b407d$export$8aafdd7901afa57f;

});

parcelRegister("6RJVA", function(module, exports) {
const $ccfe16213375d02d$export$c05408ef703373ad = [
    'confluence-page',
    'jira-work-item'
];
module.exports["SYNC_BLOCK_PRODUCTS"] = $ccfe16213375d02d$export$c05408ef703373ad;

});

parcelRegister("eq95w", function(module, exports) {
/**
 * @generated SignedSource<<853df61adc11e11eeea4029bf35e527e>>
 * @relayHash 833a199280e17468b888b75415571623
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2
const $9206d19da4400201$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "location"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "location",
                    "variableName": "location"
                }
            ],
            "concreteType": "WebPanel",
            "kind": "LinkedField",
            "name": "webPanels",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "moduleKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "completeKey"
                },
                {
                    "kind": "ScalarField",
                    "name": "html"
                },
                {
                    "kind": "ScalarField",
                    "name": "location"
                },
                {
                    "kind": "ScalarField",
                    "name": "label"
                },
                {
                    "kind": "ScalarField",
                    "name": "weight"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "WebPanelLocationQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "WebPanelLocationQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "833a199280e17468b888b75415571623",
            "id": "757c41bf66d4b23344db601f044d5ddb1c4983731abd0744dfca530decb91fa2",
            "metadata": {},
            "name": "WebPanelLocationQuery",
            "operationKind": "query",
            "text": "query WebPanelLocationQuery($location:String,$contentId:ID,$spaceKey:String){webPanels(location:$location,contentId:$contentId,key:$spaceKey){moduleKey,completeKey,html,location,label,weight,name}}"
        }
    };
}();
$9206d19da4400201$var$node.hash = "d375ecd281e94a7575edd0ac7360eb54";
var $9206d19da4400201$export$2e2bcd8739ae039 = $9206d19da4400201$var$node;
module.exports["default"] = $9206d19da4400201$export$2e2bcd8739ae039;

});

parcelRegister("744ND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d51e4a53b773461fcacb3f2ef49e80e0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $524ca136d29d3c89$var$_react = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("42omo")));

var $524ca136d29d3c89$var$_baseNew = $524ca136d29d3c89$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $524ca136d29d3c89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $524ca136d29d3c89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $524ca136d29d3c89$var$_react.default.createElement($524ca136d29d3c89$var$_baseNew.default, Object.assign({
        name: "WarningOutlineIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.383c.996-1.816 3.605-1.817 4.602-.002l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972.002L1.68 11.834c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$524ca136d29d3c89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $524ca136d29d3c89$var$_default = module.exports.default = $524ca136d29d3c89$var$WarningOutlineIcon;

});

parcelRegister("9Z1sw", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $eq95w = parcelRequire("eq95w");


var $42omo = parcelRequire("42omo");


var $iRRvH = parcelRequire("iRRvH");


var $bavCP = parcelRequire("bavCP");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $9wGTI = parcelRequire("9wGTI");


var $ep3mz = parcelRequire("ep3mz");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $eSLr0 = parcelRequire("eSLr0");


var $3QyBm = parcelRequire("3QyBm");


var $gTyTP = parcelRequire("gTyTP");


var $iqPSe = parcelRequire("iqPSe");

const $0aea74171df1eb15$export$d97dfe528d83a912 = (0, $eq95w.default);
const $0aea74171df1eb15$var$UFOWebPanelLocationWrapper = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { children: children, locationName: locationName, panels: panels } = t0;
    if (!(0, $9wGTI.fg)("confluence_annotate_3p_web_panel")) return children;
    const panelHasContent = panels?.length && panels.some($0aea74171df1eb15$var$_temp);
    if (!panelHasContent) return children;
    const t1 = `web-panel-${locationName}`;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
            name: t1
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : ({ children: children, locationName: locationName, panels: panels })=>{
    if (!(0, $9wGTI.fg)('confluence_annotate_3p_web_panel')) return children;
    // If all panels are empty, exclude it from UFOThirdPartySegment
    const panelHasContent = panels?.length && panels.some((panel)=>panel.html !== '');
    if (!panelHasContent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iRRvH.UFOThirdPartySegment), {
        name: `web-panel-${locationName}`
    }, children);
};
const $0aea74171df1eb15$export$2482f01f112556a = ({ location: location, style: style = {}, renderWhenLoading: renderWhenLoading, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', children: children, onCompleted: onCompleted })=>{
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { isLivePagesFeatureEnabled: isLivePagesFeatureEnabled } = (0, $gTyTP.useIsLivePagesFeatureEnabled)();
    const EXPERIENCE_NAME_BY_LOCATION = {
        [(0, $eSLr0.ATL_FOOTER)]: (0, $irVI7.EXTENSION_POINT_HOME_FOOTER_EXPERIENCE),
        [(0, $eSLr0.ATL_GENERAL)]: (0, $irVI7.EXTENSION_POINT_HOME_HEADER_EXPERIENCE),
        [(0, $eSLr0.ATL_EDITOR_SAVEBAR)]: (0, $irVI7.EXTENSION_POINT_EDITOR_SAVEBAR_EXPERIENCE)
    };
    const experienceName = EXPERIENCE_NAME_BY_LOCATION[location] || null;
    (0, $42omo.useEffect)(()=>{
        if (experienceName) experienceTracker.start({
            name: experienceName
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    // TODO: The task to remove this hack is captured in CFE-1873.
    // There's some weird scenario where the UI ends up with a space key of "byDraft" relating to the way tinymce
    // creates content. Given that it's tinymce specific, I'm applying this hack for now and we can remove it once we're
    // at 100% rollout for the Fabric editor.
    if (spaceIdentifier === 'byDraft') return null;
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766 */ style: style,
        "data-vc-ignore-if-no-layout-shift": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bavCP.QueryInterop), {
        query: $0aea74171df1eb15$export$d97dfe528d83a912,
        variables: variables,
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    }, ({ data: data, loading: loading, error: error })=>{
        // For transitions, loading and data is true
        if (loading && data) return null;
        if (!renderWhenLoading) {
            if (loading || error || !data) return null;
        }
        let panels = (data?.webPanels || []).filter((panel)=>panel);
        if (isLivePagesFeatureEnabled) panels = (0, $3QyBm.filterConnectAppsFromExtensionPoints)(location, panels);
        // For panels that don't have a placeholder
        if (!renderWhenLoading && !panels.length) {
            if (experienceName) experienceTracker.succeed({
                name: experienceName
            });
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0aea74171df1eb15$var$UFOWebPanelLocationWrapper, {
            locationName: location,
            panels: panels
        }, children ? children({
            panels: panels
        }) : panels.map((panel)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iqPSe.WebPanel), {
                key: panel.completeKey,
                panelId: panel.completeKey,
                html: panel.html
            });
        })), experienceName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: experienceName
        }) : null);
    }));
};
function $0aea74171df1eb15$var$_temp(panel) {
    return panel.html !== "";
}
module.exports["WebPanelLocationQuery"] = $0aea74171df1eb15$export$d97dfe528d83a912;
module.exports["WebPanelLocation"] = $0aea74171df1eb15$export$2482f01f112556a;

});

parcelRegister("iqPSe", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $brpfO = parcelRequire("brpfO");


var $6mKj3 = parcelRequire("6mKj3");


var $6UM2Q = parcelRequire("6UM2Q");


var $gIaMn = parcelRequire("gIaMn");


var $gEtAQ = parcelRequire("gEtAQ");

const $c50a10795e04dcb9$export$bbe14c99ac0820b3 = (0, $3u0dr.isReactCompilerActiveV1)() ? function WebPanel(t0) {
    const $ = (0, $frIzR.c)(18);
    const { html: html, panelId: panelId } = t0;
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    let t1;
    if ($[0] !== html) {
        let t2;
        if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /"moduleLocation"\s*:\s*"atl\.general"/;
            $[2] = t2;
        } else t2 = $[2];
        t1 = html.match(t2);
        $[0] = html;
        $[1] = t1;
    } else t1 = $[1];
    const moduleLocationMatch = t1;
    let t2;
    if ($[3] !== moduleLocationMatch) {
        t2 = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
        $[3] = moduleLocationMatch;
        $[4] = t2;
    } else t2 = $[4];
    const isMatchForActivatable = t2;
    let t3;
    if ($[5] !== isMatchForActivatable || $[6] !== ssrSuccess) {
        t3 = ()=>{
            const container = containerRef.current;
            if (!container) return;
            if (isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false)) {
                if (window?.__HYDRATABLE__) {
                    const scriptElement = container.querySelector("script.ap-iframe-body-script");
                    if (scriptElement) {
                        const scriptContent = scriptElement.textContent || "";
                        const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                        if (match) {
                            const uniqueKey = match[1];
                            const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                            if (iframe) return;
                        }
                    }
                }
                if (ssrSuccess) setSsrSuccess(false);
            }
            (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false));
        };
        $[5] = isMatchForActivatable;
        $[6] = ssrSuccess;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== html || $[9] !== isMatchForActivatable || $[10] !== panelId || $[11] !== ssrSuccess) {
        t4 = [
            html,
            panelId,
            ssrSuccess,
            isMatchForActivatable
        ];
        $[8] = html;
        $[9] = isMatchForActivatable;
        $[10] = panelId;
        $[11] = ssrSuccess;
        $[12] = t4;
    } else t4 = $[12];
    (0, $42omo.useLayoutEffect)(t3, t4);
    let t5;
    if ($[13] !== html || $[14] !== isMatchForActivatable || $[15] !== panelId || $[16] !== ssrSuccess) {
        t5 = isMatchForActivatable && (0, $6mKj3.expVal)("confluence_frontend_early_webpanel_initialization", "isEnabled", false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
            id: panelId ?? "WebPanel",
            triggers: [
                {
                    type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
                }
            ],
            ssrSuccess: ssrSuccess,
            analyticsName: "WebPanel"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: containerRef,
            "data-vc-ignore-if-no-layout-shift": true,
            dangerouslySetInnerHTML: {
                __html: html
            }
        });
        $[13] = html;
        $[14] = isMatchForActivatable;
        $[15] = panelId;
        $[16] = ssrSuccess;
        $[17] = t5;
    } else t5 = $[17];
    return t5;
} : function WebPanel({ html: html, panelId: panelId }) {
    const containerRef = (0, $42omo.useRef)(null);
    const [ssrSuccess, setSsrSuccess] = (0, $42omo.useState)(true);
    const moduleLocationMatch = html.match(/"moduleLocation"\s*:\s*"atl\.general"/);
    // Restrict to just atl-general for now
    const isMatchForActivatable = Boolean(moduleLocationMatch) && (0, $gEtAQ.isSpaceOverview)();
    (0, $42omo.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (isMatchForActivatable && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false)) {
            if (window?.__HYDRATABLE__) {
                const scriptElement = container.querySelector('script.ap-iframe-body-script');
                if (scriptElement) {
                    const scriptContent = scriptElement.textContent || '';
                    const match = scriptContent.match(/"uniqueKey":"([^"]+)"/);
                    if (match) {
                        const uniqueKey = match[1];
                        // Find iframe whose id contains the uniqueKey
                        const iframe = container.querySelector(`iframe[id*="${uniqueKey}"]`);
                        if (iframe) return;
                    }
                }
            }
            if (ssrSuccess) setSsrSuccess(false);
        }
        (0, $brpfO.evalLegacyConnectInlineScripts)(container, (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false));
    }, [
        html,
        panelId,
        ssrSuccess,
        isMatchForActivatable
    ]);
    return isMatchForActivatable && (0, $6mKj3.expVal)('confluence_frontend_early_webpanel_initialization', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6UM2Q.ActivatableComponent), {
        id: panelId ?? 'WebPanel',
        triggers: [
            {
                type: (0, $gIaMn.ActivationTriggerType).SSR_ONLY
            }
        ],
        ssrSuccess: ssrSuccess,
        analyticsName: "WebPanel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: containerRef,
        "data-vc-ignore-if-no-layout-shift": true,
        dangerouslySetInnerHTML: {
            __html: html
        }
    });
};
module.exports["WebPanel"] = $c50a10795e04dcb9$export$bbe14c99ac0820b3;

});

parcelRegister("brpfO", function(module, exports) {

var $cpjd2 = parcelRequire("cpjd2");

const $5886a35f608ee97f$var$evalScripts = (allScripts)=>{
    allScripts.forEach((elementScript)=>{
        /**
		 * When evaluating the connect scripts, the eval function inherits the context in which is it called.
		 *
		 * This means that the eval function will have access to the variables and functions
		 * in the current scope. One of these variables is the `require` passed in from Atlaspack's module system.
		 *
		 * Since the eval scripts rely on AMD's require being globally available, and Atlaspack
		 * is now shadowing that variable, we need to evaluate the scripts in the global scope.
		 *
		 * We can do this using "indirect" eval, see the MDN docs for more info:
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval#direct_and_indirect_eval
		 *
		 * Assigning the eval function to a variable is enough to trigger the indirect eval behavior,
		 * and the scripts will be able to access the global require.
		 */ const evalInGlobalScope = eval;
        evalInGlobalScope(elementScript.innerHTML);
    });
};
function $5886a35f608ee97f$export$5beb7086100d432e(container, isEarlyInitFGEnabled = false) {
    // Connect macros have an inline script that doesn't work automatically when
    // rendered in react using dangerouslySetInnerHTML. This script evaluates any
    // connect macro.
    if (!container) return Promise.reject(new Error('evalLegacyConnectInlineScripts missing container argument'));
    const connectScripts = Array.from(container.querySelectorAll('script.ap-iframe-body-script'));
    const macroScripts = Array.from(container.querySelectorAll('script.cc-macro-body-script'));
    const allScripts = connectScripts.concat(macroScripts);
    // If the connect resources are preloaded, we don't need to download them again, just evaluate the scripts.
    if (window.__CONNECT_RESOURCES_PRELOADED__ && isEarlyInitFGEnabled) {
        $5886a35f608ee97f$var$evalScripts(allScripts);
        return Promise.resolve(null);
    }
    return new Promise((resolve)=>{
        if (allScripts.length > 0) // Download the connect web resources required to render an add-on before evaluating the inline scripts.
        (0, $cpjd2.requireLegacyWRM)([
            // ensure navigator-context misc dep is loaded before navigator-context
            'wr!confluence.web.resources:querystring',
            // resource to provide the context value of AP.navigator.getLocation
            'wr!confluence.web.resources:navigator-context',
            'wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-resources-v5'
        ], ()=>{
            $5886a35f608ee97f$var$evalScripts(allScripts);
            resolve(null);
        }, ()=>{});
        else resolve(null);
    });
}
module.exports["evalLegacyConnectInlineScripts"] = $5886a35f608ee97f$export$5beb7086100d432e;

});

parcelRegister("6UM2Q", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9s45p = parcelRequire("9s45p");


var $75bK2 = parcelRequire("75bK2");


var $hRdzX = parcelRequire("hRdzX");

function $68e0b10beef6f399$export$1db2f2faaee8467f({ children: children, triggers: triggers, onActivate: onActivate, id: id, analyticsName: analyticsName, ssrSuccess: ssrSuccess }) {
    const gate = (0, $42omo.useMemo)(()=>(0, $9s45p.makeGate)(), []);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const renderChildren = (0, $42omo.useCallback)(()=>{
        return children;
    }, [
        children
    ]);
    const activateComponent = (0, $42omo.useCallback)((reason)=>{
        if (gate?.getStatus() === 'suspended') {
            onActivate?.(reason);
            if (analyticsName) createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: 'activatableComponent',
                    action: 'activated',
                    actionSubject: 'activatableComponent',
                    attributes: {
                        analyticsName: analyticsName,
                        triggers: triggers,
                        boundaryId: id,
                        activationReason: reason
                    }
                }
            }).fire();
            gate.resolve();
        }
    }, [
        gate,
        id,
        onActivate,
        createAnalyticsEvent,
        analyticsName,
        triggers
    ]);
    const hostRefWithActivation = (0, $hRdzX.useActivationTriggers)({
        triggers: triggers,
        gate: gate,
        activateComponent: activateComponent,
        boundaryId: id,
        analyticsName: analyticsName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ref: hostRefWithActivation,
        "data-hydration-shield": id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $75bK2.Boundary), {
        gate: gate,
        id: id,
        render: renderChildren,
        ssrSuccess: ssrSuccess,
        activateComponent: activateComponent,
        resolved: gate?.getStatus?.() === 'resolved',
        boundaryName: analyticsName || id,
        triggers: triggers
    }));
}
module.exports["ActivatableComponent"] = $68e0b10beef6f399$export$1db2f2faaee8467f;

});

parcelRegister("1a6Dn", function(module, exports) {
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports

var $T1bCI = parcelRequire("T1bCI");


var $hrAmX = parcelRequire("hrAmX");

class $d3905c2d386f370c$export$c59406a16f2704a5 extends (0, $T1bCI.Container) {
    constructor(...args){
        super(...args);
        this.state = {
            floatingBanners: []
        };
        this.showFloating = (name, height)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.push({
                    name: name,
                    height: height
                });
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
            else if (this.state.floatingBanners[index].height !== height) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray[index].height = height;
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.hideFloating = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index > -1) this.setState((state)=>{
                const newArray = [
                    ...state.floatingBanners
                ];
                newArray.splice(index, 1);
                return {
                    ...state,
                    floatingBanners: newArray
                };
            });
        };
        this.getFloatingHeightBefore = (name)=>{
            const index = (0, $hrAmX.findBanner)(name, this.state.floatingBanners);
            if (index === -1) return 0;
            return this.state.floatingBanners.slice(0, index).reduce((height, banner)=>{
                return height + banner.height;
            }, 0);
        };
        this.getFloatingHeight = ()=>this.state.floatingBanners.reduce((height, banner)=>height + banner.height, 0);
    }
}
module.exports["FloatingBannerStateContainer"] = $d3905c2d386f370c$export$c59406a16f2704a5;

});

parcelRegister("8WfxO", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $eSLr0 = parcelRequire("eSLr0");


var $ep3mz = parcelRequire("ep3mz");


var $6mKj3 = parcelRequire("6mKj3");


var $dS3n9 = parcelRequire("dS3n9");

const $720c81ac24834d84$export$dc9cc84753faedac = (0, $3u0dr.isReactCompilerActiveV1)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const atlGeneralHeightChanges = (0, $42omo.useRef)(t0);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)($720c81ac24834d84$var$_temp);
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: contentId, spaceKey: spaceKey } = t1;
    let t2;
    if ($[1] !== contentId || $[2] !== spaceKey) {
        t2 = {
            location: (0, $eSLr0.ATL_GENERAL),
            fetchPolicy: "cache-first",
            spaceKey: spaceKey,
            contentId: contentId
        };
        $[1] = contentId;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)(t2);
    const isATLGeneralWebPanelFixed = panels.length > 0;
    let t3;
    let t4;
    if ($[4] !== isATLGeneralWebPanelFixed) {
        t3 = ()=>{
            const listener = (e)=>{
                let newHeight;
                if ((0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
                    setWebPanelHeight(e?.detail?.height ?? 0);
                    newHeight = e?.detail?.height ?? 0;
                } else {
                    setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                    newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
                }
                if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__)) {
                    const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__ || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                    if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                    window.__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__ = atlGeneralHeightChanges.current;
                }
            };
            if (isATLGeneralWebPanelFixed) document.addEventListener("atlGeneralWebPanelHeightUpdated", listener);
            return ()=>{
                if (isATLGeneralWebPanelFixed) document.removeEventListener("atlGeneralWebPanelHeightUpdated", listener);
            };
        };
        t4 = [
            isATLGeneralWebPanelFixed
        ];
        $[4] = isATLGeneralWebPanelFixed;
        $[5] = t3;
        $[6] = t4;
    } else {
        t3 = $[5];
        t4 = $[6];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[7] !== isATLGeneralWebPanelFixed || $[8] !== webPanelHeight) {
        t5 = {
            isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
            atlGeneralWebPanelHeight: webPanelHeight
        };
        $[7] = isATLGeneralWebPanelFixed;
        $[8] = webPanelHeight;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ()=>{
    const atlGeneralHeightChanges = (0, $42omo.useRef)([]);
    const [webPanelHeight, setWebPanelHeight] = (0, $42omo.useState)(()=>{
        if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
            const initialHeight = window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'];
            return initialHeight ?? 0;
        } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
    });
    const [{ contentId: contentId, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { panels: panels } = (0, $dS3n9.useWebPanelLocation)({
        location: (0, $eSLr0.ATL_GENERAL),
        fetchPolicy: 'cache-first',
        spaceKey: spaceKey,
        contentId: contentId
    });
    const isATLGeneralWebPanelFixed = panels.length > 0;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            let newHeight;
            if ((0, $6mKj3.expVal)('confluence_p2m_style_recalc_and_expand_joint_exp', 'isEnabled', false)) {
                setWebPanelHeight(e?.detail?.height ?? 0);
                newHeight = e?.detail?.height ?? 0;
            } else {
                setWebPanelHeight($720c81ac24834d84$var$getAtlGeneralWebPanelHeight());
                newHeight = $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
            }
            // Track ATL General Webpanel height changes for page initial load
            if (typeof window !== 'undefined' && Boolean(window.__SSR_RENDERED__)) {
                // Last height is the SSR rendered height or last observed height
                const lastHeight = atlGeneralHeightChanges.current.length === 0 ? window['__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__'] || 0 : atlGeneralHeightChanges.current[atlGeneralHeightChanges.current.length - 1];
                // If the last height is not the same as the new height, track the change
                if (lastHeight !== newHeight) atlGeneralHeightChanges.current.push(newHeight);
                window['__ATL_GENERAL_WEBPANEL_HEIGHT_CHANGES__'] = atlGeneralHeightChanges.current;
            }
        };
        if (isATLGeneralWebPanelFixed) document.addEventListener('atlGeneralWebPanelHeightUpdated', listener);
        return ()=>{
            if (isATLGeneralWebPanelFixed) document.removeEventListener('atlGeneralWebPanelHeightUpdated', listener);
        };
    }, [
        isATLGeneralWebPanelFixed
    ]);
    return {
        isATLGeneralWebPanelFixed: isATLGeneralWebPanelFixed,
        atlGeneralWebPanelHeight: webPanelHeight
    };
};
const $720c81ac24834d84$var$getAtlGeneralWebPanelHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--atl-general-webpanel-height')) || 0;
};
function $720c81ac24834d84$var$_temp() {
    if (typeof window !== "undefined" && Boolean(window.__SSR_RENDERED__) && (0, $6mKj3.expVal)("confluence_p2m_style_recalc_and_expand_joint_exp", "isEnabled", false)) {
        const initialHeight = window.__ATL_GENERAL_WEBPANEL_INITIAL_HEIGHT__;
        return initialHeight ?? 0;
    } else return $720c81ac24834d84$var$getAtlGeneralWebPanelHeight();
}
module.exports["useATLGeneralWebPanelListener"] = $720c81ac24834d84$export$dc9cc84753faedac;

});

parcelRegister("dS3n9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");


var $c3Qwv = parcelRequire("c3Qwv");


var $7zgzO = parcelRequire("7zgzO");


var $9Z1sw = parcelRequire("9Z1sw");

const $9fffd50bbcc7c343$export$c8daa7260f75e213 = ({ spaceKey: spaceKey, contentId: contentId, location: location, fetchPolicy: // Query is preloaded on the server-side. reused the preloaded data.
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
fetchPolicy = 'cache-and-network', onCompleted: onCompleted })=>{
    const { getQueryParams: getQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const queryParams = getQueryParams();
    const spaceIdentifier = spaceKey || (0, $c3Qwv.getSingleParam)(queryParams, 'spaceKey') || (0, $c3Qwv.getSingleParam)(queryParams, 'key');
    const contentIdentifier = contentId || (0, $c3Qwv.getSingleParam)(queryParams, 'pageId');
    const variables = contentIdentifier ? {
        contentId: contentIdentifier,
        location: location
    } : {
        spaceKey: spaceIdentifier,
        location: location
    };
    const baseOptions = {
        variables: variables,
        ...onCompleted && {
            onCompleted: onCompleted
        }
    };
    const { loading: loading, data: data, error: error } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)((0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: fetchPolicy
    });
    const panels = (data?.webPanels || []).filter((panel)=>panel);
    return {
        panels: panels,
        loading: loading,
        error: error
    };
};
module.exports["useWebPanelLocation"] = $9fffd50bbcc7c343$export$c8daa7260f75e213;

});

parcelRegister("gtauf", function(module, exports) {
/* eslint-disable require-unicode-regexp  */ const $5a9379de970b4a33$export$aafb32b192c8228c = (node)=>{
    return {
        blockInstanceId: node.attrs.localId,
        content: node.content.toJSON(),
        resourceId: node.attrs.resourceId
    };
};
const $5a9379de970b4a33$export$c5b34fb9069ebb1d = (localId, resourceId)=>{
    return {
        type: 'syncBlock',
        attrs: {
            localId: localId,
            resourceId: resourceId
        }
    };
};
const $5a9379de970b4a33$export$cd9b0caaea319019 = (node)=>{
    if (node.type !== 'syncBlock' || !node.attrs || !('localId' in node.attrs) || !('resourceId' in node.attrs) || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$648ff8dd259e0d9c = (node)=>{
    if (node.type.name !== 'syncBlock' || !node.attrs?.localId || !node.attrs?.resourceId || typeof node.attrs.localId !== 'string' || typeof node.attrs.resourceId !== 'string') return undefined;
    return $5a9379de970b4a33$export$c5b34fb9069ebb1d(node.attrs.localId, node.attrs.resourceId);
};
const $5a9379de970b4a33$export$18b85168a73dad03 = (nodes)=>{
    return nodes.map((node)=>$5a9379de970b4a33$export$648ff8dd259e0d9c(node)).filter((node)=>node !== undefined) || [];
};
const $5a9379de970b4a33$export$2cf4a74c3e18f31a = (resourceId)=>{
    const match = resourceId.match(/^(confluence-page|jira-work-item)\/([^/]+)/);
    if (match?.[2]) return {
        sourceProduct: match[1],
        sourceContentId: match[2]
    };
    throw new Error(`Invalid resourceId: ${resourceId}`);
};
module.exports["convertSyncBlockPMNodeToSyncBlockData"] = $5a9379de970b4a33$export$aafb32b192c8228c;
module.exports["createSyncBlockNode"] = $5a9379de970b4a33$export$c5b34fb9069ebb1d;
module.exports["convertSyncBlockJSONNodeToSyncBlockNode"] = $5a9379de970b4a33$export$cd9b0caaea319019;
module.exports["convertPMNodesToSyncBlockNodes"] = $5a9379de970b4a33$export$18b85168a73dad03;
module.exports["getContentIdAndProductFromResourceId"] = $5a9379de970b4a33$export$2cf4a74c3e18f31a;

});

parcelRegister("lEQpi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3RNNl = parcelRequire("3RNNl");


var $dBGrG = parcelRequire("dBGrG");

class $f2fbfd8272c84174$export$d353efb45bc662f4 {
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.referenceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
        this.sourceSyncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    }
    get referenceManager() {
        return this.referenceSyncBlockStoreManager;
    }
    get sourceManager() {
        return this.sourceSyncBlockStoreManager;
    }
    destroy() {
        this.referenceSyncBlockStoreManager.destroy();
        this.sourceSyncBlockStoreManager.destroy();
    }
    constructor(dataProvider){
        this.referenceSyncBlockStoreManager = void 0;
        this.sourceSyncBlockStoreManager = void 0;
        // In future, if reference manager needs to reach to source manager and read it's current in memorey cache
        // we can pass the source manager as a parameter to the reference manager constructor
        this.sourceSyncBlockStoreManager = new (0, $dBGrG.SourceSyncBlockStoreManager)(dataProvider);
        this.referenceSyncBlockStoreManager = new (0, $3RNNl.ReferenceSyncBlockStoreManager)(dataProvider);
    }
}
const $f2fbfd8272c84174$var$createSyncBlockStoreManager = (dataProvider)=>{
    return new $f2fbfd8272c84174$export$d353efb45bc662f4(dataProvider);
};
const $f2fbfd8272c84174$export$d95b04bc16414394 = (dataProvider, fireAnalyticsEvent)=>{
    const syncBlockStoreManager = (0, $42omo.useMemo)(()=>{
        const syncBlockStoreManager = $f2fbfd8272c84174$var$createSyncBlockStoreManager(dataProvider);
        return syncBlockStoreManager;
    }, [
        dataProvider
    ]);
    syncBlockStoreManager.setFireAnalyticsEvent(fireAnalyticsEvent);
    return syncBlockStoreManager;
};
module.exports["SyncBlockStoreManager"] = $f2fbfd8272c84174$export$d353efb45bc662f4;
module.exports["useMemoizedSyncBlockStoreManager"] = $f2fbfd8272c84174$export$d95b04bc16414394;

});

parcelRegister("3RNNl", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $4FxUL = parcelRequire("4FxUL");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $eB0XO = parcelRequire("eB0XO");


var $4wATI = parcelRequire("4wATI");


var $gtauf = parcelRequire("gtauf");

class $bf9ff2ea047058dc$export$fb04276dca31302e {
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    setExperiences(fetchExperience, fetchSourceInfoExperience, saveExperience) {
        // don't reset experiences after they have already been set
        if (!this.fetchExperience || !this.fetchSourceInfoExperience || !this.saveExperience) {
            this.fetchExperience = fetchExperience;
            this.fetchSourceInfoExperience = fetchSourceInfoExperience;
            this.saveExperience = saveExperience;
        }
    }
    generateResourceIdForReference(sourceId) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        return this.dataProvider.generateResourceIdForReference(sourceId);
    }
    updateFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    getInitialSyncBlockData(resourceId) {
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)('', resourceId);
        return this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
    }
    /**
   * Refreshes the subscriptions for all sync blocks.
   * @returns {Promise<void>}
   */ async refreshSubscriptions() {
        if (this.isRefreshingSubscriptions) return;
        this.isRefreshingSubscriptions = true;
        const syncBlocks = [];
        for (const [resourceId, callbacks] of this.subscriptions.entries())Object.keys(callbacks).forEach((localId)=>{
            syncBlocks.push((0, $gtauf.createSyncBlockNode)(localId, resourceId));
        });
        try {
            // fetch latest data for all subscribed sync blocks
            // this function will update the cache and call the subscriptions
            await this.fetchSyncBlocksData(syncBlocks);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        } finally{
            this.isRefreshingSubscriptions = false;
        }
    }
    fetchSyncBlockSourceInfo(resourceId) {
        try {
            if (!resourceId || !this.dataProvider) {
                // make sure experience has been started before throwing error
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.start({});
                throw new Error('Data provider or resourceId not set');
            }
            if (this.syncBlockSourceInfoRequests.get(resourceId)) return;
            const existingSyncBlock = this.getFromCache(resourceId);
            if (!existingSyncBlock) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.start({});
                throw new Error('No existing sync block to fetch source info for');
            }
            // skip if source URL and title are already present
            if (existingSyncBlock.data?.sourceURL && existingSyncBlock.data?.sourceTitle) return;
            // only start experience if there is data to fetch
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.start({});
            const { sourceAri: sourceAri, product: product, blockInstanceId: blockInstanceId } = existingSyncBlock.data || {};
            if (!sourceAri || !product || !blockInstanceId) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.failure({
                    reason: 'SourceAri, product or blockInstanceId missing'
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('SourceAri, product or blockInstanceId missing'));
                return;
            }
            this.syncBlockSourceInfoRequests.set(resourceId, true);
            this.dataProvider.fetchSyncBlockSourceInfo(blockInstanceId, sourceAri, product, this.fireAnalyticsEvent).then((sourceInfo)=>{
                if (!sourceInfo) {
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.failure({
                        reason: 'No source info returned'
                    });
                    return;
                }
                this.updateCacheWithSourceInfo(resourceId, sourceInfo);
                if (sourceInfo.title) this.updateSourceTitleSubscriptions(resourceId, sourceInfo.title);
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    if (sourceInfo.title && sourceInfo.url) this.fetchSourceInfoExperience?.success();
                    else this.fetchSourceInfoExperience?.failure({
                        reason: 'Missing title or url'
                    });
                }
            }).catch((error)=>{
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.failure({
                    reason: error.message
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
            }).finally(()=>{
                this.syncBlockSourceInfoRequests.delete(resourceId);
            });
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchSourceInfoExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
        }
    }
    /**
   * Fetch sync block data for a given array of sync block nodes.
   * @param syncBlockNodes - The array of sync block nodes to fetch data for
   * @returns The fetched sync block data results
   */ async fetchSyncBlocksData(syncBlockNodes) {
        if (syncBlockNodes.length === 0) return;
        // Don't fetch for not_found error since the source is already deleted
        const nodesToFetch = [];
        syncBlockNodes.forEach((node)=>{
            if (this.syncBlockFetchDataRequests.get(node.attrs.resourceId)) return;
            const existingSyncBlock = this.getFromCache(node.attrs.resourceId);
            if (existingSyncBlock?.error === (0, $awHlv.SyncBlockError).NotFound) return;
            nodesToFetch.push(node);
        });
        if (nodesToFetch.length === 0) return;
        // only start fetch experience if there is data to fetch
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchExperience?.start({});
        if (!this.dataProvider) throw new Error('Data provider not set');
        nodesToFetch.forEach((node)=>{
            this.syncBlockFetchDataRequests.set(node.attrs.resourceId, true);
        });
        const data = await this.dataProvider.fetchNodesData(nodesToFetch).finally(()=>{
            nodesToFetch.forEach((node)=>{
                this.syncBlockFetchDataRequests.delete(node.attrs.resourceId);
            });
        });
        const resolvedData = [];
        const successfulFetched = [];
        const failedFetch = [];
        data.forEach((syncBlockInstance)=>{
            if (!syncBlockInstance.resourceId) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) failedFetch.push({
                    reason: syncBlockInstance.error || 'Returned sync block instance does not have resource id'
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error || 'Returned sync block instance does not have resource id'));
                return;
            }
            const existingSyncBlock = this.getFromCache(syncBlockInstance.resourceId);
            const resolvedSyncBlockInstance = existingSyncBlock ? (0, $4wATI.resolveSyncBlockInstance)(existingSyncBlock, syncBlockInstance) : syncBlockInstance;
            this.updateCache(resolvedSyncBlockInstance);
            resolvedData.push(resolvedSyncBlockInstance);
            if (syncBlockInstance.error) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) failedFetch.push({
                    reason: syncBlockInstance.error,
                    resourceId: syncBlockInstance.resourceId
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(syncBlockInstance.error));
                return;
            }
            successfulFetched.push(syncBlockInstance.resourceId);
            this.fetchSyncBlockSourceInfo(resolvedSyncBlockInstance.resourceId);
        });
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
            if (data.every((syncBlockInstance)=>syncBlockInstance.resourceId && !syncBlockInstance.error)) this.fetchExperience?.success({
                metadata: {
                    successfulFetched: successfulFetched
                }
            });
            else this.fetchExperience?.failure({
                metadata: {
                    successfulFetched: successfulFetched,
                    failedFetch: failedFetch
                }
            });
        }
    }
    updateCacheWithSourceInfo(resourceId, sourceInfo) {
        const existingSyncBlock = this.getFromCache(resourceId);
        if (existingSyncBlock && existingSyncBlock.data) {
            existingSyncBlock.data.sourceURL = sourceInfo?.url;
            existingSyncBlock.data = {
                ...existingSyncBlock.data,
                sourceURL: sourceInfo?.url,
                sourceTitle: sourceInfo?.title
            };
            this.updateCache(existingSyncBlock);
        }
    }
    updateCache(syncBlock) {
        const { resourceId: resourceId } = syncBlock;
        if (resourceId) {
            this.syncBlockCache.set(resourceId, syncBlock);
            const callbacks = this.subscriptions.get(resourceId);
            if (callbacks) Object.values(callbacks).forEach((callback)=>{
                callback(syncBlock);
            });
        }
    }
    updateSourceTitleSubscriptions(resourceId, title) {
        const callbacks = this.titleSubscriptions.get(resourceId);
        if (callbacks) Object.values(callbacks).forEach((callback)=>{
            callback(title);
        });
    }
    getFromCache(resourceId) {
        return this.syncBlockCache.get(resourceId);
    }
    deleteFromCache(resourceId) {
        this.syncBlockCache.delete(resourceId);
        this.providerFactories.delete(resourceId);
    }
    subscribeToSyncBlock(resourceId, localId, callback) {
        // Cancel any pending cache deletion for this resourceId.
        // This handles the case where a block is moved - the old component unmounts
        // (scheduling deletion) but the new component mounts and subscribes before
        // the deletion timeout fires.
        const pendingDeletion = this.pendingCacheDeletions.get(resourceId);
        if (pendingDeletion) {
            clearTimeout(pendingDeletion);
            this.pendingCacheDeletions.delete(resourceId);
        }
        // add to subscriptions map
        const resourceSubscriptions = this.subscriptions.get(resourceId) || {};
        this.subscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        // New subscription means new reference synced block is added to the document
        this.isCacheDirty = true;
        const syncBlockNode = (0, $gtauf.createSyncBlockNode)(localId, resourceId);
        // call the callback immediately if we have cached data
        // prefer cache from store manager first, should update data provider to use the same cache
        const cachedData = this.getFromCache(resourceId) || this.dataProvider?.getNodeDataFromCache(syncBlockNode)?.data;
        if (cachedData) callback(cachedData);
        else this.fetchSyncBlocksData([
            syncBlockNode
        ]).catch((error)=>{
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.fetchExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        });
        return ()=>{
            const resourceSubscriptions = this.subscriptions.get(resourceId);
            if (resourceSubscriptions) {
                // Unsubscription means a reference synced block is removed from the document
                this.isCacheDirty = true;
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) {
                    this.subscriptions.delete(resourceId);
                    // Delay cache deletion to handle block moves (unmount/remount).
                    // When a block is moved, the old component unmounts before the new one mounts.
                    // By delaying deletion, we give the new component time to subscribe and
                    // cancel this pending deletion, preserving the cached data.
                    // TODO: EDITOR-4152 - Rework this logic
                    const deletionTimeout = setTimeout(()=>{
                        // Only delete if still no subscribers (wasn't re-subscribed)
                        if (!this.subscriptions.has(resourceId)) this.deleteFromCache(resourceId);
                        this.pendingCacheDeletions.delete(resourceId);
                    }, 1000);
                    this.pendingCacheDeletions.set(resourceId, deletionTimeout);
                } else this.subscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribeToSourceTitle(node, callback) {
        // check node is a sync block, as we only support sync block subscriptions
        if (node.type.name !== 'syncBlock') return ()=>{};
        const { resourceId: resourceId, localId: localId } = node.attrs;
        if (!localId || !resourceId) return ()=>{};
        const cachedData = this.getFromCache(resourceId);
        if (cachedData?.data?.sourceTitle) callback(cachedData.data.sourceTitle);
        // add to subscriptions map
        const resourceSubscriptions = this.titleSubscriptions.get(resourceId) || {};
        this.titleSubscriptions.set(resourceId, {
            ...resourceSubscriptions,
            [localId]: callback
        });
        return ()=>{
            const resourceSubscriptions = this.titleSubscriptions.get(resourceId);
            if (resourceSubscriptions) {
                delete resourceSubscriptions[localId];
                if (Object.keys(resourceSubscriptions).length === 0) this.titleSubscriptions.delete(resourceId);
                else this.titleSubscriptions.set(resourceId, resourceSubscriptions);
            }
        };
    }
    subscribe(node, callback) {
        try {
            // check node is a sync block, as we only support sync block subscriptions
            if (node.type.name !== 'syncBlock') throw new Error('Only sync block node subscriptions are supported');
            const { resourceId: resourceId, localId: localId } = node.attrs;
            if (!localId || !resourceId) throw new Error('Missing local id or resource id');
            return this.subscribeToSyncBlock(resourceId, localId, callback);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return ()=>{};
        }
    }
    /**
   * Get the URL for a sync block.
   * @param resourceId - The resource ID of the sync block
   * @returns
   */ getSyncBlockURL(resourceId) {
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock) return undefined;
        return syncBlock.data?.sourceURL;
    }
    getProviderFactory(resourceId) {
        if (!this.dataProvider) {
            const error = new Error('Data provider not set');
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            return undefined;
        }
        const { parentDataProviders: parentDataProviders, providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        let providerFactory = this.providerFactories.get(resourceId);
        if (!providerFactory) {
            providerFactory = (0, $4FxUL.default).create({
                mentionProvider: parentDataProviders?.mentionProvider,
                profilecardProvider: parentDataProviders?.profilecardProvider,
                taskDecisionProvider: parentDataProviders?.taskDecisionProvider
            });
            this.providerFactories.set(resourceId, providerFactory);
        } else {
            if (parentDataProviders?.mentionProvider) providerFactory.setProvider('mentionProvider', parentDataProviders?.mentionProvider);
            if (parentDataProviders?.profilecardProvider) providerFactory.setProvider('profilecardProvider', parentDataProviders?.profilecardProvider);
            if (parentDataProviders?.taskDecisionProvider) providerFactory.setProvider('taskDecisionProvider', parentDataProviders?.taskDecisionProvider);
        }
        if (providerCreator) try {
            this.retrieveDynamicProviders(resourceId, providerFactory, providerCreator);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        }
        return providerFactory;
    }
    getSSRProviders(resourceId) {
        if (!(0, $dh538.fg)('platform_synced_block_dogfooding')) return null;
        if (!this.dataProvider) return null;
        const { providerCreator: providerCreator } = this.dataProvider.getSyncedBlockRendererProviderOptions();
        if (!providerCreator?.createSSRMediaProvider) return null;
        const parsedResourceId = (0, $eB0XO.parseResourceId)(resourceId);
        if (!parsedResourceId) return null;
        const { contentId: contentId, product: contentProduct } = parsedResourceId;
        try {
            const mediaProvider = providerCreator.createSSRMediaProvider({
                contentId: contentId,
                contentProduct: contentProduct
            });
            if (mediaProvider) return {
                media: mediaProvider
            };
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
        }
        return null;
    }
    retrieveDynamicProviders(resourceId, providerFactory, providerCreator) {
        if (!this.dataProvider) throw new Error('Data provider not set');
        const hasMediaProvider = providerFactory.hasProvider('mediaProvider');
        const hasEmojiProvider = providerFactory.hasProvider('emojiProvider');
        if (hasMediaProvider && hasEmojiProvider) return;
        const syncBlock = this.getFromCache(resourceId);
        if (!syncBlock || !syncBlock.data?.sourceAri || !syncBlock.data?.product) {
            this.fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)('Sync block or source ari or product not found'));
            return;
        }
        const parentInfo = this.dataProvider.retrieveSyncBlockParentInfo(syncBlock.data?.sourceAri, syncBlock.data?.product);
        if (!parentInfo) throw new Error('Unable to retrive sync block parent info');
        const { contentId: contentId, contentProduct: contentProduct } = parentInfo;
        if (!hasMediaProvider) {
            if (providerCreator.createMediaProvider && contentId && contentProduct) {
                const mediaProvider = providerCreator.createMediaProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (mediaProvider) providerFactory.setProvider('mediaProvider', mediaProvider);
            }
        }
        if (!hasEmojiProvider) {
            if (providerCreator.createEmojiProvider && contentId && contentProduct) {
                const emojiProvider = providerCreator.createEmojiProvider({
                    contentProduct: contentProduct,
                    contentId: contentId
                });
                if (emojiProvider) providerFactory.setProvider('emojiProvider', emojiProvider);
            }
        }
    }
    /**
   * Update reference synced blocks on the document with the BE
   *
   * @returns true if the reference synced blocks are updated successfully, false otherwise
   */ async flush() {
        if (!this.isCacheDirty) return true;
        let success = true;
        try {
            const blocks = [];
            // Collect all reference synced blocks on the current document
            Array.from(this.subscriptions.entries()).forEach(([resourceId, callbacks])=>{
                Object.keys(callbacks).forEach((localId)=>{
                    blocks.push({
                        resourceId: resourceId,
                        localId: localId
                    });
                });
            });
            if (blocks.length === 0) {
                this.isCacheDirty = false;
                return true;
            }
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.start();
            if (!this.dataProvider) throw new Error('Data provider not set');
            // reset isCacheDirty early to prevent race condition
            // There is a race condition where if a user makes changes (create/delete) to a reference sync block
            // on a live page and the reference sync block is being saved while the user
            // is still making changes, the new changes might not be saved if they all happen
            // exactly at a time when the updateReferenceData is being executed asynchronously.
            this.isCacheDirty = false;
            const updateResult = await this.dataProvider.updateReferenceData(blocks);
            if (!updateResult.success) {
                success = false;
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                    reason: updateResult.error || 'Failed to update reference synced blocks on the document'
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(updateResult.error || 'Failed to update reference synced blocks on the document'));
            }
        } catch (error) {
            success = false;
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/referenceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.updateReferenceErrorPayload)(error.message));
        } finally{
            if (!success) // set isCacheDirty back to true for cases where it failed to update the reference synced blocks on the BE
            this.isCacheDirty = true;
            else if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.success();
        }
        return success;
    }
    destroy() {
        this.dataProvider = undefined;
        this.syncBlockCache.clear();
        this.subscriptions.clear();
        this.titleSubscriptions.clear();
        this.syncBlockFetchDataRequests.clear();
        this.syncBlockSourceInfoRequests.clear();
        this.providerFactories.clear();
        this.isRefreshingSubscriptions = false;
        this.providerFactories.forEach((providerFactory)=>{
            providerFactory.destroy();
        });
        this.providerFactories.clear();
        this.fireAnalyticsEvent = undefined;
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.syncBlockCache = void 0;
        // Keeps track of addition and deletion of reference synced blocks on the document
        // This starts as true to always flush the cache when document is saved for the first time
        // to cater the case when a editor seesion is closed without document being updated right after reference block is deleted
        this.isCacheDirty = true;
        this.subscriptions = void 0;
        this.titleSubscriptions = void 0;
        this.providerFactories = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockFetchDataRequests = void 0;
        this.syncBlockSourceInfoRequests = void 0;
        this.isRefreshingSubscriptions = false;
        // Track pending cache deletions to handle block moves (unmount/remount)
        // When a block is moved, the old component unmounts before the new one mounts,
        // causing the cache to be deleted prematurely. We delay deletion to allow
        // the new component to subscribe and cancel the pending deletion.
        this.pendingCacheDeletions = void 0;
        this.fetchExperience = void 0;
        this.fetchSourceInfoExperience = void 0;
        this.saveExperience = void 0;
        this.syncBlockCache = new Map();
        this.subscriptions = new Map();
        this.titleSubscriptions = new Map();
        this.dataProvider = dataProvider;
        this.syncBlockFetchDataRequests = new Map();
        this.syncBlockSourceInfoRequests = new Map();
        this.providerFactories = new Map();
        this.pendingCacheDeletions = new Map();
    }
}
module.exports["ReferenceSyncBlockStoreManager"] = $bf9ff2ea047058dc$export$fb04276dca31302e;

});

parcelRegister("4wATI", function(module, exports) {

var $awHlv = parcelRequire("awHlv");

const $165aef3c3dcb8be4$export$dcc459f28c1cd2fd = (oldResult, newResult)=>{
    // if the old result has no data, we simply return the new result
    if (!oldResult.data) return newResult;
    else if (!newResult.data) {
        // return the old result if there was an error, e.g. network error, but not if not found or forbidden
        if (newResult.error === (0, $awHlv.SyncBlockError).NotFound || newResult.error === (0, $awHlv.SyncBlockError).Forbidden) return newResult;
        else return oldResult;
    }
    // otherwise, we merge the two results, preserving the sourceURL and sourceTitle from the old result if it exists
    return {
        ...newResult,
        data: {
            ...newResult.data,
            sourceURL: newResult.data?.sourceURL || oldResult.data?.sourceURL || undefined,
            sourceTitle: newResult.data?.sourceTitle || oldResult.data?.sourceTitle || undefined
        }
    };
};
module.exports["resolveSyncBlockInstance"] = $165aef3c3dcb8be4$export$dcc459f28c1cd2fd;

});

parcelRegister("dBGrG", function(module, exports) {

var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

class $297b92badcfd6d6a$export$9c6faa8962092f36 {
    setFireAnalyticsEvent(fireAnalyticsEvent) {
        this.fireAnalyticsEvent = fireAnalyticsEvent;
    }
    setCreateExperience(createExperience) {
        this.createExperience = createExperience;
    }
    setSaveExperience(saveExperience) {
        this.saveExperience = saveExperience;
    }
    setDeleteExperience(deleteExperience) {
        this.deleteExperience = deleteExperience;
    }
    isSourceBlock(node) {
        return node.type.name === 'bodiedSyncBlock';
    }
    /**
   * Add/update a sync block node to/from the local cache
   * @param syncBlockNode - The sync block node to update
   */ updateSyncBlockData(syncBlockNode) {
        try {
            if (!this.isSourceBlock(syncBlockNode)) throw new Error('Invalid sync block node type provided for updateSyncBlockData');
            const { localId: localId, resourceId: resourceId } = syncBlockNode.attrs;
            if (!localId || !resourceId) throw new Error('Local ID or resource ID is not set');
            const syncBlockData = (0, $gtauf.convertSyncBlockPMNodeToSyncBlockData)(syncBlockNode);
            this.syncBlockCache.set(resourceId, {
                ...syncBlockData,
                isDirty: true
            });
            return true;
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            this.fireAnalyticsEvent?.((0, $cFpEg.updateCacheErrorPayload)(error.message));
            return false;
        }
    }
    /**
   * Save content of bodiedSyncBlock nodes in local cache to backend
   *
   * @returns true if saving all nodes successfully, false if fail to save some/all nodes
   */ async flush() {
        try {
            const bodiedSyncBlockNodes = [];
            const bodiedSyncBlockData = [];
            Array.from(this.syncBlockCache.values()).forEach((syncBlockData)=>{
                // Don't flush nodes that are waiting to be deleted to avoid nodes being re-created
                // Don't flush nodes that haven't been updated since we last flushed
                if (!syncBlockData.pendingDeletion && syncBlockData.isDirty) {
                    bodiedSyncBlockNodes.push({
                        type: 'bodiedSyncBlock',
                        attrs: {
                            localId: syncBlockData.blockInstanceId,
                            resourceId: syncBlockData.resourceId
                        }
                    });
                    bodiedSyncBlockData.push(syncBlockData);
                    // reset isDirty early to prevent race condition
                    // There is a race condition where if a user makes changes to a source sync block
                    // on a live page and the source sync block is being saved while the user
                    // is still making changes, the new changes might not be saved if they all happen
                    // exactly at a time when the writeNodesData is being executed asynchronously.
                    syncBlockData.isDirty = false;
                }
            });
            if (bodiedSyncBlockNodes.length === 0) return Promise.resolve(true);
            // only start the save experience if we have sync blocks to save
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.start({});
            if (!this.dataProvider) throw new Error('Data provider not set');
            const writeResults = await this.dataProvider.writeNodesData(bodiedSyncBlockNodes, bodiedSyncBlockData);
            writeResults.forEach((result)=>{
                // set isDirty to true for cases where it failed to save the sync block to the BE
                if (result.resourceId && result.error && result.error !== (0, $awHlv.SyncBlockError).NotFound) {
                    const cachedData = this.syncBlockCache.get(result.resourceId);
                    if (cachedData) cachedData.isDirty = true;
                }
            });
            const successfulSaved = writeResults.filter((result)=>result.resourceId && !result.error).map((result)=>({
                    resourceId: result.resourceId
                }));
            const failedSave = writeResults.filter((result)=>!result.resourceId || result.error).map((result)=>({
                    resourceId: result.resourceId || 'unknown',
                    failReason: result.error || 'Failed to save sync blocks'
                }));
            if (writeResults.every((result)=>result.resourceId && !result.error)) {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.success({
                    metadata: {
                        successfulSaved: successfulSaved
                    }
                });
                return true;
            } else {
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                    metadata: {
                        successfulSaved: successfulSaved,
                        failedSave: failedSave
                    }
                });
                else writeResults.filter((result)=>!result.resourceId || result.error).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(result.error || 'Failed to write data'));
                });
                return false;
            }
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.saveExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.updateErrorPayload)(error.message));
            return false;
        }
    }
    registerPendingCreation(resourceId) {
        this.pendingResourceId = resourceId;
    }
    /**
   * Register callback function (which inserts node, handles focus etc) to be used later when creation to backend succeed
   */ registerCreationCallback(callback) {
        this.creationCallback = callback;
    }
    /**
   *  Fires callback to insert node (if creation is successful) and clears pending creation data
   * @param success
   */ commitPendingCreation(success) {
        if (success && this.creationCallback) this.creationCallback();
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
    }
    /**
   *
   * @returns true if waiting for the result of saving new bodiedSyncBlock to backend
   */ hasPendingCreation() {
        return !!this.pendingResourceId;
    }
    registerConfirmationCallback(callback) {
        this.confirmationCallback = callback;
        return ()=>{
            this.confirmationCallback = undefined;
        };
    }
    requireConfirmationBeforeDelete() {
        return !!this.confirmationCallback;
    }
    /**
   * @returns attributes for a new bodiedSyncBlock node
   */ generateBodiedSyncBlockAttrs() {
        if (!this.dataProvider) throw new Error('Data provider not set or source id not set');
        const { resourceId: resourceId, localId: localId } = this.dataProvider.generateResourceId();
        return {
            resourceId: resourceId,
            localId: localId
        };
    }
    /**
   * Create a bodiedSyncBlock node with empty content to backend
   * @param attrs attributes Ids of the node
   */ createBodiedSyncBlockNode(attrs) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            const { resourceId: resourceId, localId: blockInstanceId } = attrs;
            this.dataProvider.createNodeData({
                content: [],
                blockInstanceId: blockInstanceId,
                resourceId: resourceId
            }).then((result)=>{
                const resourceId = result.resourceId;
                if (resourceId) this.commitPendingCreation(true);
                else {
                    this.commitPendingCreation(false);
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.failure({
                        reason: result.error || 'Failed to create bodied sync block'
                    });
                    else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(result.error || 'Failed to create bodied sync block'));
                }
            }).catch((error)=>{
                this.commitPendingCreation(false);
                (0, $hWRJP.logException)(error, {
                    location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
                });
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.failure({
                    reason: error.message
                });
                else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
            });
            this.registerPendingCreation(resourceId);
        } catch (error) {
            if (this.hasPendingCreation()) this.commitPendingCreation(false);
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.createExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.createErrorPayload)(error.message));
        }
    }
    async delete(syncBlockIds, onDelete, onDeleteCompleted) {
        try {
            if (!this.dataProvider) throw new Error('Data provider not set');
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, true);
            });
            const results = await this.dataProvider.deleteNodesData(syncBlockIds.map((attrs)=>attrs.resourceId));
            let callback;
            const isDeleteSuccessful = results.every((result)=>result.success);
            onDeleteCompleted(isDeleteSuccessful);
            if (isDeleteSuccessful) {
                onDelete();
                callback = (Ids)=>this.syncBlockCache.delete(Ids.resourceId);
                this.clearPendingDeletion();
            } else {
                callback = (Ids)=>{
                    this.setPendingDeletion(Ids, false);
                };
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                    const successfulDeleted = results.filter((result)=>result.success).map((result)=>({
                            resourceId: result.resourceId
                        }));
                    const failedDelete = results.filter((result)=>!result.success).map((result)=>({
                            resourceId: result.resourceId || 'unknown',
                            failReason: result.error || 'Failed to delete sync block'
                        }));
                    this.deleteExperience?.failure({
                        metadata: {
                            successfulDeleted: successfulDeleted,
                            failedDelete: failedDelete
                        }
                    });
                } else results.filter((result)=>result.resourceId === undefined).forEach((result)=>{
                    this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(result.error || 'Failed to delete synced block'));
                });
            }
            syncBlockIds.forEach(callback);
            return isDeleteSuccessful;
        } catch (error) {
            syncBlockIds.forEach((Ids)=>{
                this.setPendingDeletion(Ids, false);
            });
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/sourceSyncBlockStoreManager'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) this.deleteExperience?.failure({
                reason: error.message
            });
            else this.fireAnalyticsEvent?.((0, $cFpEg.deleteErrorPayload)(error.message));
            onDeleteCompleted(false);
            return false;
        }
    }
    isRetryingDeletion() {
        return !!this.deletionRetryInfo;
    }
    async retryDeletion() {
        if (!this.deletionRetryInfo) return Promise.resolve();
        const { syncBlockIds: syncBlockIds, onDelete: onDelete, onDeleteCompleted: onDeleteCompleted } = this.deletionRetryInfo;
        if (this.confirmationCallback) await this.delete(syncBlockIds, onDelete, onDeleteCompleted);
    }
    clearPendingDeletion() {
        this.deletionRetryInfo?.destroyCallback();
        this.deletionRetryInfo = undefined;
    }
    /**
   *
   * @param syncBlockIds - The sync block ids to delete
   * @param onDelete - The callback to delete sync block node from document
   * @param onDeleteCompleted - The callback for after the deletion is saved to BE (whether successful or not)
   * @param destroyCallback - The callback to clear any reference stored for deletion (regardless if deletion is completed or abort)
   */ async deleteSyncBlocksWithConfirmation(syncBlockIds, onDelete, onDeleteCompleted, destroyCallback) {
        if (this.confirmationCallback) {
            const confirmed = await this.confirmationCallback(syncBlockIds.length);
            if (confirmed) {
                const isDeleteSuccessful = await this.delete(syncBlockIds, onDelete, onDeleteCompleted);
                if (!isDeleteSuccessful) // If deletion failed, save deletion info for potential retry
                this.deletionRetryInfo = {
                    syncBlockIds: syncBlockIds,
                    onDelete: onDelete,
                    onDeleteCompleted: onDeleteCompleted,
                    destroyCallback: destroyCallback
                };
                else destroyCallback();
            } else destroyCallback();
        }
    }
    destroy() {
        this.syncBlockCache.clear();
        this.confirmationCallback = undefined;
        this.pendingResourceId = undefined;
        this.creationCallback = undefined;
        this.dataProvider = undefined;
        this.clearPendingDeletion();
    }
    constructor(dataProvider){
        this.dataProvider = void 0;
        this.fireAnalyticsEvent = void 0;
        this.syncBlockCache = void 0;
        this.confirmationCallback = void 0;
        this.deletionRetryInfo = void 0;
        this.pendingResourceId = void 0;
        this.creationCallback = void 0;
        this.createExperience = void 0;
        this.saveExperience = void 0;
        this.deleteExperience = void 0;
        this.setPendingDeletion = (Ids, value)=>{
            const syncBlock = this.syncBlockCache.get(Ids.resourceId);
            if (syncBlock) syncBlock.pendingDeletion = value;
        };
        this.dataProvider = dataProvider;
        this.syncBlockCache = new Map();
    }
}
module.exports["SourceSyncBlockStoreManager"] = $297b92badcfd6d6a$export$9c6faa8962092f36;

});

parcelRegister("a7tZV", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $dh538 = parcelRequire("dh538");


var $awHlv = parcelRequire("awHlv");


var $cFpEg = parcelRequire("cFpEg");


var $gtauf = parcelRequire("gtauf");

const $fb1e42d9cacf5d6e$export$2b02427d5640395b = (manager, resourceId, localId, fireAnalyticsEvent)=>{
    // Initialize both states from a single cache lookup to avoid race conditions.
    // When a block is moved/remounted, the old component's cleanup may clear the cache
    // before or after the new component mounts. By doing a single lookup, we ensure
    // consistency between syncBlockInstance and isLoading initial values.
    const [{ syncBlockInstance: syncBlockInstance, isLoading: isLoading }, setFetchState] = (0, $42omo.useState)(()=>{
        if (resourceId) {
            const initialData = manager?.referenceManager?.getInitialSyncBlockData(resourceId);
            return {
                syncBlockInstance: initialData ?? null,
                isLoading: initialData === undefined
            };
        }
        return {
            syncBlockInstance: null,
            isLoading: true
        };
    });
    const reloadData = (0, $42omo.useCallback)(async ()=>{
        if (isLoading) return;
        try {
            const syncBlockNode = resourceId && localId ? (0, $gtauf.createSyncBlockNode)(localId, resourceId) : null;
            if (!syncBlockNode) throw new Error('Failed to create sync block node from resourceid and localid');
            setFetchState((prev)=>({
                    ...prev,
                    isLoading: true
                }));
            // Fetch sync block data, the `subscribeToSyncBlock` will update the state once data is fetched
            await manager.referenceManager.fetchSyncBlocksData([
                syncBlockNode
            ]);
        } catch (error) {
            (0, $hWRJP.logException)(error, {
                location: 'editor-synced-block-provider/useFetchSyncBlockData'
            });
            if ((0, $dh538.fg)('platform_synced_block_dogfooding')) manager?.referenceManager?.fetchExperience?.failure({
                reason: error.message
            });
            else fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
            // Set error state if fetching fails
            setFetchState({
                syncBlockInstance: {
                    resourceId: resourceId || '',
                    error: (0, $awHlv.SyncBlockError).Errored
                },
                isLoading: false
            });
            return;
        }
        setFetchState((prev)=>({
                ...prev,
                isLoading: false
            }));
    }, [
        isLoading,
        localId,
        manager.referenceManager,
        resourceId,
        fireAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = manager.referenceManager.subscribeToSyncBlock(resourceId || '', localId || '', (data)=>{
            setFetchState({
                syncBlockInstance: data,
                isLoading: false
            });
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        localId,
        manager.referenceManager,
        resourceId
    ]);
    return {
        isLoading: isLoading,
        ssrProviders: resourceId ? manager.referenceManager.getSSRProviders(resourceId) : null,
        providerFactory: manager.referenceManager.getProviderFactory(resourceId || ''),
        reloadData: reloadData,
        syncBlockInstance: syncBlockInstance
    };
};
module.exports["useFetchSyncBlockData"] = $fb1e42d9cacf5d6e$export$2b02427d5640395b;

});


//# sourceMappingURL=CommentsPanelFilterMenu.35ecdb03.js.map
